import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { toggleSignUpModal } from "@actions/authModalsActions";
import "./FeatureCard.sass";

const FeatureCard = ({
  titleLine1,
  titleLine2,
  description,
  button: ButtonComponent,
  buttonText,
  backgroundImage,
  backgroundImageMobile,
  imageSrc,
  imageAlt,
  variant = "default",
}) => {
  const dispatch = useDispatch();
  const containerRef = useRef(null);

  const handleButtonClick = () => {
    dispatch(toggleSignUpModal(true));
  };

  const containerStyle = backgroundImage
    ? {
        "--bg-image": `url(${backgroundImage})`,
        backgroundImage: `url(${backgroundImage})`,
      }
    : {};

  useEffect(() => {
    if (backgroundImageMobile && containerRef.current) {
      const mediaQuery = window.matchMedia("(max-width: 1023px)");

      const updateBackground = () => {
        if (mediaQuery.matches) {
          containerRef.current.style.backgroundImage = `url(${backgroundImageMobile})`;
        } else {
          containerRef.current.style.backgroundImage = backgroundImage
            ? `url(${backgroundImage})`
            : "";
        }
      };

      updateBackground();
      mediaQuery.addEventListener("change", updateBackground);

      return () => mediaQuery.removeEventListener("change", updateBackground);
    }
  }, [backgroundImageMobile, backgroundImage]);

  return (
    <section className="feature-card">
      <div
        ref={containerRef}
        className={`feature-card__container feature-card__container--${variant}`}
        style={containerStyle}
      >
        <div
          className={`feature-card__content feature-card__content--${variant}`}
        >
          <div className={`feature-card__text feature-card__text--${variant}`}>
            <h2 className="feature-card__title">{titleLine1}</h2>

            {titleLine2 && (
              <h2 className="feature-card__title feature-card__title--second">
                {titleLine2}
              </h2>
            )}

            <p className="feature-card__description">{description}</p>

            {ButtonComponent && (
              <ButtonComponent
                type="button"
                variant="light"
                className="feature-card__button"
                onClick={handleButtonClick}
              >
                {buttonText}
              </ButtonComponent>
            )}
          </div>

          {imageSrc && (
            <div className="feature-card__image-wrapper">
              <img
                src={imageSrc}
                alt={imageAlt}
                className="feature-card__image"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default FeatureCard;
